import React, { useEffect, useState } from "react"
import { Card, CardContent } from "@material-ui/core"
import { RowModule } from "../../../../component/atoms/RowModule/RowModule"
import { RowText } from "../../../../component"
import { useTranslation } from "react-i18next"
import { toRupiah } from "../../../helpers/TextHelper"
import { useDispatch, useSelector } from "react-redux"
import { getPaymentSummary } from "../../../../redux/actions/AreaAction"

const Summary = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { Area } = useSelector((state) => state)

  const [paymentSummary, setPaymentSummary] = useState(null)
  function fetchData() {
    dispatch(getPaymentSummary())
  }

  useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
    if (Area.paymentSummary) {
      setPaymentSummary(Area.paymentSummary)
    }
  }, [Area.paymentSummary])

  return (
    <Card className="mb-10 p-4">
      <CardContent className="px-8 py-4">
        <RowModule customColumnCss={"col-md-4"} customSeparator={"my-0"}>
          <RowText
            label={t("label_planting_season_unpaid")}
            value={<div className="txt-18 font-weight-normal ">{toRupiah(paymentSummary?.unpaid)}</div>}
          />
          <RowText
            label={t("label_planting_season_partial")}
            value={<div className="txt-18 font-weight-normal ">{toRupiah(paymentSummary?.partial_paid)}</div>}
          />
          <RowText
            label={t("label_planting_season_paid")}
            value={<div className="txt-18 font-weight-normal ">{toRupiah(paymentSummary?.paid)}</div>}
          />
        </RowModule>
      </CardContent>
    </Card>
  )
}

export default Summary
